import { apiSlice } from '../../../../store/apiSlice';

export const extendedApiSlice = apiSlice
  .enhanceEndpoints({
    addTagTypes: [
      'quotes',
      'special-members',
      'membership-stats',
      'waitlist',
      'archived',
      'payment-history',
    ],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getAllQuotes: builder.query({
        query: ({ status, type, start_date, end_date }) => ({
          url: 'fishery/fishery-quotes',
          params: { status: status, param_type: type, start_date, end_date },
        }),
        providesTags: ['quotes'],
      }),

      deleteQuote: builder.mutation({
        query: (id) => ({
          url: 'fishery/fishery-quotes/delete',
          method: 'delete',
          params: { quote_id: id },
        }),
        invalidatesTags: (result, error) => [{ type: 'quotes' }],
      }),

      postReservationBooking: builder.mutation({
        query: (data) => ({
          method: 'post',
          url: `booking/new`,
          data,
        }),
        invalidatesTags: (result, error) => [{ type: '' }],
      }),
      postQuoteBooking: builder.mutation({
        query: (data) => ({
          method: 'post',
          url: `fishery/fishery-quotes`,
          data,
        }),
        invalidatesTags: (result, error) => [{ type: 'quotes' }],
      }),
      updateQuoteBooking: builder.mutation({
        query: (data) => ({
          method: 'put',
          url: `fishery/fishery-quotes`,
          data,
        }),
        invalidatesTags: (result, error) => [{ type: 'quotes' }],
      }),
      updateQuotePaid: builder.mutation({
        query: (data) => ({
          method: 'put',
          url: `fishery/fishery-quotes/mark_paid`,
          data,
        }),
        invalidatesTags: (result, error) => [{ type: 'quotes' }],
      }),
    }),
  });

export const {
  useUpdateQuoteBookingMutation,
  useUpdateQuotePaidMutation,
  useGetAllQuotesQuery,
  useLazyGetAllQuotesQuery,
  useDeleteQuoteMutation,
  usePostQuoteBookingMutation,
  usePostReservationBookingMutation,
} = extendedApiSlice;
